<script>
import Vue from "vue";
import { ref, defineComponent, reactive } from "@vue/composition-api";
import { Message } from "element-ui";
import axios from "@/assets/js/axios";
export default defineComponent({
    props: {
        value: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        ckey: {
            type: String,
            required: true,
        },
    },
    setup(props, { emit }) {
        const loading = ref(false);
        const form = reactive({
            reason: props.value,
        });
        const handleConfirmClick = async () => {
            try {
                if (!form.reason) {
                    Message.warning("请输入输单原因");
                    throw new Error();
                }
                loading.value = true;
                const res = await axios({
                    method: "POST",
                    url:
                        Vue.prototype.$customerUrl +
                        "/v1/Config/OrderInputReasonSave",
                    data: {
                        key: props.ckey,
                        reason: form.reason,
                    },
                });
                if (!res.isSuccess) throw new Error();
                Message.success("操作成功");
                emit("success");
            } catch {
                null;
            } finally {
                loading.value = false;
            }
        };
        return {
            loading,
            form,
            handleConfirmClick,
        };
    },
});
</script>

<template>
    <el-dialog top="60px" :visible="true" width="674px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <div class="flow-dialog" v-loading="loading">
            <div class="top">{{ `${$props.type}输单原因` }}</div>
            <div class="body">
                <el-form size="small" label-width="100px">
                    <el-form-item label="输单原因">
                        <el-input v-model.trim="form.reason" />
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="handleConfirmClick" type="primary" size="small">创建</el-button>
                        <el-button @click="$emit('close')" size="small">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </el-dialog>
</template>

<style scoped lang="scss">
::v-deep .el-dialog__header {
    display: none;
}
::v-deep .el-dialog__body {
    padding: 0;
}
.flow-dialog {
    box-sizing: border-box;
    font-size: 16px;
}
.top {
    box-sizing: border-box;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    color: #3a3a3a;
    border-bottom: 1px solid #d9d9d9;
}
.body {
    box-sizing: border-box;
    padding: 20px;
}
</style>
